import React from "react";
import TilbudCard from "./Cards/TilbudCard";
import GodtattCard from "./Cards/GodtattCard";
import AvslåttCard from "./Cards/AvslåttCard";
import SøknadCard from "./Cards/SøknadCard";
import SøknadsfristCard from "./Cards/SøknadsFristCard";
import UtgåttTilbudCard from "./Cards/UtgåttTilbudCard";
import {BarnBarnehageplassStatus} from "../../api/barnehageplassStatus";

interface Props {
    alleBarnBarnehageplassStatus: Array<BarnBarnehageplassStatus> | undefined;
}

export function BarnCardOversikt({alleBarnBarnehageplassStatus}: Props) {

    if (alleBarnBarnehageplassStatus === undefined) {
        return ""
    }

    const cardVisningIPrioritertRekkefølgeAvStatusCard = (barn: BarnBarnehageplassStatus) => {
        const barnNavn = barn.navn;
        const statusCard = barn.statusCard;
        switch (barn.statusCard.type) {
            case "STÅENDE_TILBUD":
                return statusCard.sak ? <TilbudCard barnNavn={barnNavn} svarFrist={statusCard.sak.frist}
                                                    applicationId={statusCard.sak.id}/> : null;

            case "GODTATT_TILBUD":
                return statusCard.sak ? <GodtattCard barnNavn={barnNavn}/> : null;

            case "AVSLÅTT_TILBUD":
                return <AvslåttCard barnNavn={barnNavn}/>;

            case "UTGÅTT_TILBUD":
                return statusCard.sak ? <UtgåttTilbudCard barnNavn={barnNavn} applicationId={statusCard.sak.id}
                                                          svarFrist={statusCard.sak.frist}/> : null;

            case "MOTTATT_SØKNAD":
                return statusCard.sak ? <SøknadCard barnNavn={barnNavn} applicationId={statusCard.sak.id}
                                                    søknadsDato={statusCard.sak.dato}/> : null;

            case "SØKNADSFRIST":
                return statusCard.søknadsfrist ?
                    <SøknadsfristCard barnNavn={barnNavn} søknadsfrist={new Date(statusCard.søknadsfrist)}/> : null;
        }
    }

    return (
        <>
            {alleBarnBarnehageplassStatus.map((barn) =>
                <div className={"my-size-24"} key={barn.ident}>
                    {cardVisningIPrioritertRekkefølgeAvStatusCard(barn)}
                </div>
            )}
        </>)
}
